// Helpers for the Reports section (week dates, visit grouping, color hashing)

export const getCurrentWeekDates = () => {
  const today = new Date();
  const currentDay = today.getDay();
  const monday = new Date(today);
  monday.setDate(today.getDate() - (currentDay === 0 ? 6 : currentDay - 1));
  return Array.from({ length: 5 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d;
  });
};

export const getNextWeekDates = () => {
  const cw = getCurrentWeekDates();
  const nextMonday = new Date(cw[0]);
  nextMonday.setDate(cw[0].getDate() + 7);
  return Array.from({ length: 5 }, (_, i) => {
    const d = new Date(nextMonday);
    d.setDate(nextMonday.getDate() + i);
    return d;
  });
};

export const formatWeekRange = (weekDates) =>
  `${weekDates[0].toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${weekDates[4].toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;

export const WEEKDAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
export const WEEKDAY_COLORS = ['text-purple-600', 'text-pink-600', 'text-orange-600', 'text-green-600', 'text-blue-600'];

const STUDY_COLORS = [
  'bg-blue-200 text-blue-800',
  'bg-yellow-200 text-yellow-800',
  'bg-green-200 text-green-800',
  'bg-purple-200 text-purple-800',
  'bg-pink-200 text-pink-800',
  'bg-indigo-200 text-indigo-800',
];
export const getStudyColor = (studyName) => STUDY_COLORS[studyName.length % STUDY_COLORS.length];

export const getVisitsForDateAndAssignee = (date, assigneeName, users, visits) => {
  const dateStr = date.toISOString().split('T')[0];
  const user = users.find(u => u.name === assigneeName);
  return visits.filter(v => {
    const vd = new Date(v.date).toISOString().split('T')[0];
    if (vd !== dateStr) return false;
    if (user?.sites?.length) return user.sites.includes(v.site_id);
    return false;
  });
};

export const getVisitsForDateAndSite = (date, siteId, visits) => {
  const dateStr = date.toISOString().split('T')[0];
  return visits.filter(v => {
    const vd = new Date(v.date).toISOString().split('T')[0];
    return vd === dateStr && v.site_id === siteId;
  });
};

export const getTasksForVisit = (visit, tasks) =>
  tasks.filter(t =>
    t.study_id === visit.study_id &&
    (t.visit?.includes(visit.patient_name) ||
      t.visit?.includes(visit.visit_type) ||
      t.visit?.toLowerCase().includes(visit.visit_type?.toLowerCase()) ||
      new Date(t.sliding_date || t.planned_date).toISOString().split('T')[0] ===
        new Date(visit.date).toISOString().split('T')[0])
  );

export const VisitCell = ({ visit, studies, onClick }) => {
  const study = studies.find(s => s.id === visit.study_id);
  const studyName = study?.name || 'Unknown Study';
  return (
    <div
      onClick={onClick}
      className={`text-xs p-2 rounded ${getStudyColor(studyName)} text-center cursor-pointer hover:opacity-80 transition-opacity`}
      title="Click to view related tasks"
    >
      <div className="font-medium">{studyName}</div>
      <div className="text-xs opacity-90 mt-1">{visit.visit_type?.replace('_', ' ')?.toUpperCase() || 'Visit'}</div>
      <div className="text-xs opacity-75 mt-1">{visit.patient_name}</div>
    </div>
  );
};
